/* eslint-disable import/prefer-default-export */
import { UPDATE_UI } from './types';

export const updateUI = (update) => ({
  type: UPDATE_UI,
  payload: update,
});
